import React from 'react';
import { motion } from 'framer-motion';
import { FaGithub, FaLinkedin, FaEnvelope } from 'react-icons/fa';
import heroImage from '../assets/women-web-developer-with-laptop.png';
import '../App.css';

const containerVariants = {
  hidden: { opacity: 0 },
  visible: {
    opacity: 1,
    transition: { staggerChildren: 0.15 }
  }
};

const itemVariants = {
  hidden: { y: 30, opacity: 0 },
  visible: { 
    y: 0, opacity: 1, 
    transition: { duration: 0.8, ease: [0.4, 0, 0.2, 1] } 
  }
};

const Hero = ({ t }) => {
  return (
    <motion.section 
      className="hero-section"
      variants={containerVariants}
      initial="hidden"
      animate="visible"
    >
      <div className="hero-content-split">
        {/* LEFT COLUMN: Texts and Actions */}
        <div className="hero-left">
          {t.title && (
            <motion.div variants={itemVariants} className="hero-pill glass-panel">
              ✨ {t.title}
            </motion.div>
          )}
          
          <motion.h1 variants={itemVariants} className="hero-title-main">
            {t.name.split(' ')[0]} <span className="text-gradient">{t.name.split(' ')[1]}</span>
          </motion.h1>
          
          <motion.h2 variants={itemVariants} className="hero-subtitle">
            {t.subtitle}
          </motion.h2>
          
          <motion.p variants={itemVariants} className="hero-desc-main">
            {t.description}
          </motion.p>
          
          <motion.div variants={itemVariants} className="hero-actions">
            <a href="mailto:medineuzundev@gmail.com" className="btn-primary">
              <FaEnvelope /> {t.email}
            </a>
            <a href="https://github.com/MedineUzun" target="_blank" rel="noreferrer" className="btn-secondary glass-panel">
              <FaGithub size={20} />
            </a>
            <a href="https://linkedin.com/in/medine-uzun-160848223" target="_blank" rel="noreferrer" className="btn-secondary glass-panel">
              <FaLinkedin size={20} />
            </a>
          </motion.div>

          {t.stats && t.stats.length > 0 && (
            <motion.div variants={itemVariants} className="hero-stats-row glass-panel">
              {t.stats.map((st, i) => (
                <div className="stat-item-clean" key={i}>
                  <h3 className="stat-val-clean">{st.val}</h3>
                  <span className="stat-label-clean">{st.label}</span>
                </div>
              ))}
            </motion.div>
          )}
        </div>

        {/* RIGHT COLUMN: Hero Illustration */}
        <div className="hero-right">
          <motion.div 
            className="hero-tech-showcase"
            initial={{ scale: 0.8, opacity: 0 }}
            animate={{ scale: 1, opacity: 1 }}
            transition={{ duration: 1.2, ease: [0.4, 0, 0.2, 1] }}
          >
             <div className="cube-glow-1"></div>
             <div className="cube-glow-2"></div>
             
             <motion.img 
               src={heroImage} 
               alt="Web Developer" 
               className="hero-main-illustration"
               animate={{ y: [0, -20, 0] }}
               transition={{ repeat: Infinity, duration: 6, ease: "easeInOut" }}
             />
          </motion.div>
        </div>
      </div>
    </motion.section>
  );
};

export default Hero;
